import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import type { Bank } from '@gcv/shared';
import { useQuery } from '@tanstack/react-query';

import { BanksApi } from 'api/BanksApi';
import { getFiBankStore } from 'stores/FiBankStore';
import { BANK_KEY } from 'tanstack-hooks/keys';
import { useUser } from 'tanstack-hooks/user';
import { updatePendoAccountForFi } from 'third-party-integrations/pendo';

export function useBank() {
  const navigate = useNavigate();
  const banksApi = new BanksApi();
  const bankStore = getFiBankStore();
  const { user, userBankId } = useUser();

  const {
    data: bank,
    isLoading: isLoadingBank,
    isError: isBankError
  } = useQuery<Bank>({
    enabled: !!userBankId.length,
    queryKey: [BANK_KEY, userBankId],
    queryFn: () => banksApi.getBankById(userBankId)
  });

  useEffect(() => {
    if (bank?.id) {
      bankStore.updateBank(bank);
      updatePendoAccountForFi(bank, user);
    }
  }, [bank]);

  useEffect(() => {
    if (isBankError) {
      navigate('/error');
    }
  }, [isBankError]);

  return { bank, isLoadingBank, isBankError };
}
